import { format } from "date-fns";

import { getDateFnsLocale } from "@/lib/date-fns-locale";
import { useLocale } from "@/lib/i18n";

interface EarlyWarningTableHeaderDateProps {
  date: string;
  narrow: boolean;
  onClick: () => void;
}

const EarlyWarningTableHeaderDate = ({
  date,
  narrow,
  onClick,
}: EarlyWarningTableHeaderDateProps) => {
  const locale = useLocale();
  const parsedDate = new Date(date);
  const dateFnsLocale = getDateFnsLocale(locale);

  return (
    <div style={{ textTransform: "capitalize" }} onClick={onClick}>
      {format(parsedDate, "eeeeee d", { locale: dateFnsLocale })}
      {narrow ? <br /> : " "}
      {format(parsedDate, "MMM", { locale: dateFnsLocale })}
    </div>
  );
};

export default EarlyWarningTableHeaderDate;
